export default {"src":"/_next/static/image/public/images/flags/flag_227.b28295c3e9b5e28a51b4b7d231755c7e.svg","height":16,"width":24};